import { TypographyOptions } from '@mui/material/styles/createTypography';

const typography: TypographyOptions = {
	fontFamily: 'Quicksand, sans-serif!important',
	h1: {
		fontWeight: 700,
	},
	h2: {
		fontWeight: 700,
	},
	h3: {
		fontWeight: 600,
	},
	h4: {
		fontWeight: 600,
	},
	h5: {
		fontWeight: 600,
	},
	h6: {
		fontWeight: 600,
	},
	body1: {
		fontWeight: 500,
	},
	body2: {
		fontWeight: 500,
	},
};

export default typography;
